import { Button } from '@avanta/shared/components/ui/Button';
import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { SelectController } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { useActiveConversation } from '@avanta/shared/stores/chat/conversations';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useFetchEspecialities, useCreateCoupon } from './hooks';

export const CreateCouponForm = (): React.ReactElement => {
  const { hideDialog } = useDialogContext();
  const activeConversation = useActiveConversation();
  const { data: specialities } = useFetchEspecialities(activeConversation?.otherUser.id ?? '');
  const { mutateAsync: createCoupon, isPending } = useCreateCoupon();
  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm<{ specialitiesBookable: string }>();
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  const handleOnSubmit = async (data: { specialitiesBookable: string }): Promise<void> => {
    const randomCode1 = Math.random().toString(36).substring(2, 12).toUpperCase();
    const randomCode2 = Math.random().toString(36).substring(2, 12).toUpperCase();
    const commonPayload = {
      discount: 100,
      expirationInHours: 24,
      specialitiesBookable: Number(data.specialitiesBookable),
    };
    await createCoupon({
      userId: activeConversation?.otherUser.id ?? '',
      body: { ...commonPayload, code: randomCode1 },
    });
    await createCoupon({
      userId: activeConversation?.otherUser.id ?? '',
      body: { ...commonPayload, code: randomCode2 },
    });
    hideDialog();
  };

  return (
    <Dialog title={t('Chat.UserInfo.Coupons.create.heading')} open>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit(handleOnSubmit)}>
        <SelectController
          name="specialitiesBookable"
          placeholder={t('Chat.UserInfo.Coupons.Form.speciality.placeholder')}
          className="w-full"
          control={control}
          options={specialities ?? []}
          rules={{ required: true }}
        />
        <Button type="submit" variant="secondary" disabled={!isValid} isLoading={isPending}>
          {t('Chat.UserInfo.Coupons.cta')}
        </Button>
      </form>
    </Dialog>
  );
};
